import type { LeagueRules } from "../content/preview-competition.types";
import { recordOf } from "./manifest-record";
function positiveNumber(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) && value > 0
    ? value
    : null;
}
function nonEmptyString(value: unknown): string | null {
  return typeof value === "string" && value ? value : null;
}
export function settingsFacts(settings: unknown): LeagueRules {
  const s = recordOf(settings);
  const ladder = recordOf(s.ladder);
  const ranking = recordOf(ladder.ranking);
  const scheduler = recordOf(ladder.scheduler);
  const minutes = positiveNumber(s.round_interval_minutes);
  const seconds = positiveNumber(s.round_interval_seconds);
  const roundMinutes =
    minutes ?? (seconds && seconds % 60 === 0 ? seconds / 60 : null);
  const seats =
    positiveNumber(s.team_count) ?? positiveNumber(scheduler.team_count);
  const scoring = scoringFrom(ranking);

  const strategy = nonEmptyString(scheduler.strategy);
  let pairing: string | null = null;

  switch (strategy) {
    case "swiss_neighbor":
      pairing = "swiss pairing";
      break;
    case "round_robin":
      pairing = "round robin";
      break;
    case "team_n":
      pairing = seats ? `${seats}-seat episodes` : null;
      break;
  }

  return {
    roundMinutes,
    seats,
    scoring,
    pairing,
    minEpisodes: positiveNumber(scheduler.min_episodes_per_entrant),
  };
}

function scoringFrom(
  ranking: Readonly<Record<string, unknown>>,
): string | null {
  const algorithm = nonEmptyString(ranking.algorithm);
  let scoring: string | null = null;

  switch (algorithm) {
    case "elo": {
      const start = positiveNumber(ranking.initial_rating);
      const k = positiveNumber(ranking.k_factor);
      scoring = `Elo${start ? ` from ${start}` : ""}${k ? ` · k ${k}` : ""}`;
      break;
    }
    case "openskill":
      scoring = "OpenSkill (Plackett-Luce) · MMR is μ − 3σ";
      break;
    case "score": {
      const ratedK = positiveNumber(ranking.rated_k);
      scoring = ratedK
        ? `a decaying average of round scores · k ${ratedK}`
        : "Ranked by round score";
      break;
    }
  }

  return scoring;
}
